<template>
    <b-modal
        :id="'sub-assignment-show-partner-add-modal-' + subAssignmentIn.id"
        :title="$t('assignment.add_collaboration_partner')"
        modal-class="apprentice-default-modal"
        size="lg"
        ok-only
        @show="onShow"
        :ok-title="$t('common.close')">
        <p v-if="assignmentCooperationIn.maximum">
            {{
                $t('assignment.you_can_add_x_more_partners_at_most', {
                    amount: assignmentCooperationIn.maximum - amountIn,
                })
            }}
        </p>
        <design-2021-apprentice-data-table
            class="available-students-table"
            :items="users"
            :fields="fields">
            <template v-slot:cell(actions)="data">
                <div class="partner-user-actions">
                    <b-button
                        class="btn-add btn-add-student"
                        variant="primary-icon"
                        @click="addUser(data.item.id)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </b-modal>
</template>

<script>
import { ords } from '../../../../../app';

export default {
    name: 'design-2021-assignment-show-sub-assignment-partner-add-modal-component',
    props: {
        subAssignmentIn: Object,
        assignmentPartnerIn: Object,
        projectIdIn: Number,
        assignmentCooperationIn: Object,
        amountIn: Number,
    },
    data() {
        return {
            loaded: false,
            users: [],
            subscription: null,
            fields: [
                {
                    key: 'full_name',
                    label: this.$t('common.student'),
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    methods: {
        onShow() {
            if (!this.loaded) {
                this.axios
                    .get(
                        this.routes.subAssignmentAssignmentPartnerAvailableStudents(
                            this.projectIdIn,
                            this.subAssignmentIn.id,
                        ),
                    )
                    .then(
                        (response) => {
                            ords.use('user').add(response.data);
                            this.subscription = ords
                                .use('user')
                                .whereDoesntHave('assignment_partner_users', (assignmentPartnerUserCallback) => {
                                    assignmentPartnerUserCallback.where(
                                        'assignment_partner_id',
                                        '=',
                                        this.assignmentPartnerIn.id,
                                    );
                                })
                                .get()
                                .subscribe((users) => {
                                    this.users = users;
                                });
                            this.loaded = true;
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
            }
        },

        addUser(user_id) {
            this.alert.saving();

            const data = {
                user_id: user_id,
                assignment_partner_id: this.assignmentPartnerIn.id,
            };

            this.axios.post(this.routes.assignmentPartnerUserStore(), data).then(
                (response) => {
                    this.assignmentPartnerIn.addRelation('assignment_partner_users', response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },

    destroyed() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    },
};
</script>

<style scoped lang="scss">
.available-students-table ::v-deep {
    table tbody {
        .btn-add-student {
            font-size: $default-font-size;

            &:before {
                margin-right: 0;
            }
        }
    }
}
</style>
